module.exports = __webpack_public_path__ + "img/json-mapper-task.748b79cf.svg";